import {AsyncPipe} from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {ScreenSizeService} from "src/app/modules/shared/services/screenSize.service";
import {UserAvatarComponent} from "src/app/modules/shared/components/user-avatar/user-avatar.component";
import {DiscussionParticipant} from "../../interfaces/discussion.interface";
import {AuthService} from "src/app/modules/auth/services/auth.service";
import {SocketService} from "src/app/modules/shared/services/socket.service";

@Component({
  selector: "app-discussion-panel-header",
  templateUrl: "./discussion-panel-header.component.html",
  imports: [AsyncPipe, TranslateModule, UserAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: "block shrink-0"},
})
export class DiscussionPanelHeaderComponent {
  readonly screen = inject(ScreenSizeService);
  readonly auth = inject(AuthService);
  readonly socket = inject(SocketService);
  @Input() title = "";
  @Input() subtitle = "";
  @Input() friend?: DiscussionParticipant;
  @Input() friendOnline = false;
  @Input() threadView = false;
  @Input() scrolled = false;
  @Input() detailsDisabled = false;
  @Input() detailsLoading = false;
  @Output() back = new EventEmitter<void>();
  @Output() closePanel = new EventEmitter<void>();
  @Output() details = new EventEmitter<void>();
  @ViewChild("titleElement") set titleElement(
    ref: ElementRef<HTMLElement> | undefined
  ) {
    ref?.nativeElement.focus({preventScroll: true});
  }
}
